import React, { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import axios from "axios";
import { config } from "../config";
import { useCart } from "../context/CartContext";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Merci() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [status, setStatus] = useState("checking");
  const { setOpen } = useCart();

  useEffect(() => {
    // Clear cart on successful landing
    if (!sessionId) { setStatus("nosession"); return; }
    let tries = 0;
    const poll = async () => {
      try {
        const { data } = await axios.get(`${API}/payments/status/${sessionId}`);
        if (data.payment_status === "paid") {
          localStorage.removeItem("crush_cart");
          setOpen(false);
          setStatus("paid");
          return;
        }
      } catch (e) { /* keep trying */ }
      tries += 1;
      if (tries < 6) setTimeout(poll, 2000);
      else setStatus("pending");
    };
    poll();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sessionId]);

  return (
    <main data-testid="merci-page" className="section" style={{ minHeight: "70vh" }}>
      <div className="wrap" style={{ maxWidth: 620, textAlign: "center" }}>
        <h1 className="title-xl" style={{ fontSize: "clamp(40px,9vw,72px)" }}>C'EST CRAQUÉ.</h1>
        {status === "checking" && <p style={{ color: "var(--text-muted)", marginTop: 20 }}>Vérification de votre paiement…</p>}
        {status === "paid" && (
          <p style={{ color: "var(--text-muted)", marginTop: 20 }} data-testid="merci-confirmed">
            Votre commande est confirmée — le récapitulatif arrive par email. {config.shipping.delay_text}. En attendant, venez voir les coulisses :
          </p>
        )}
        {status === "pending" && <p style={{ color: "var(--text-muted)", marginTop: 20 }}>Votre paiement est en cours de traitement. Vous recevrez un email de confirmation.</p>}
        {status === "nosession" && <p style={{ color: "var(--text-muted)", marginTop: 20 }}>Aucune commande à afficher. <Link to="/boutique" className="link-accent">Retour à la boutique</Link></p>}
        <div style={{ display: "flex", gap: 12, justifyContent: "center", marginTop: 28, flexWrap: "wrap" }}>
          <a href={config.brand.instagram || "#"} className="btn btn-secondary" data-testid="merci-instagram">Instagram</a>
          <a href={config.brand.tiktok || "#"} className="btn btn-secondary" data-testid="merci-tiktok">TikTok</a>
        </div>
      </div>
    </main>
  );
}
